<template>
  <div id="studyPathStudy" :style="{ backgroundImage: 'url(' + bgUrl + ')' }">
    <white-title-widge
      :title="title"
      :desc="desc"
      :bgFont="bgFont"
      class="studyPath_title"
    ></white-title-widge>
    <div class="conts">
      <div class="studyRoute">
        <div class="outlineBox">
          <el-tabs :tab-position="tabPosition" style="height: 659px;" @tab-click="handleClick">
            <el-tab-pane
              label=""
              v-for="(item, index) in courseData"
              :key="index"
            >
              <div slot="label" class="outlineTitle">
                <p>
                  {{ getCaptionReg(item.titles) }}({{
                    getCaption(item.titles)
                  }})
                </p>

                <span>{{ getCaption2(item.titles) }}</span>
              </div>
              <div class="outlineeInfo">
                <div v-for="(val, num) in item.desc" :key="num">
                  <em class="courseOutTitle">{{ val.title }}</em>

                  <ul class="courseOutList">
                    <li
                      v-for="(v, n) in val.content.split(/\↵|\r|\n|\r\n/)"
                      :key="n"
                    >
                      {{ v }}
                    </li>
                  </ul>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="studyBtn" @click="qimoChatClick">
          <a>马上学习</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import whiteTitleWidge from "./../asserts/common/components/whiteTitleWidge";
export default {
  components: {
    whiteTitleWidge,
  },
  data() {
    return {
      tabPosition: "left",
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
    bgUrl: {
      type: String,
      default: "",
    },
    courseData: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  methods: {
    handleClick (list) {
      this.$trackEvent(this.courseData[list.index], "点击", this.courseData[list.index])
    },
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击", "马上学习")
      window.qimoChatClick();
    },
    getCaptionReg(str) {
      str = str.split("：")[0];
      return str;
    },
    getCaption(str) {
      let str1 = "";
      if (str.lastIndexOf("（") > 0) {
        str1 = str.substring(str.indexOf("（") + 1, str.indexOf("）"));
      }
      return str1;
    },
    getCaption2(str) {
      let str1 = "";
      if (str.lastIndexOf("（") > 0) {
        str1 = str.substring(str.indexOf("：") + 1, str.indexOf("（"));
      }
      return str1;
    },
  },
};
</script>

<style lang="scss">
@import "../asserts/scss/studyPathWidge.scss";
</style>
